// What changed between two fetches, as the server judged it
// (app/safety/evaluate.compare): a verdict and headline, then the changes that
// matter — a band crossed, or a move of at least the metric's `significant`
// amount at or beyond approaching amber — most important first.
import { useState } from "react";
import { Alert, AlertTitle, Box, Button, Typography } from "@mui/material";
import {
  BAND_LABEL, VERDICT_SEVERITY, fmtMetric, fmtStepTime, metricsByField,
} from "./format";

const SHOWN = 5;

function changeText(c, metric) {
  const name = metric ? metric.label.toLowerCase() : c.field;
  const moved = metric ? `${fmtMetric(metric, c.from)} → ${fmtMetric(metric, c.to)}` : `${c.from} → ${c.to}`;
  const band = c.band_changed
    ? (BAND_LABEL[c.band_to] ? `, now ${BAND_LABEL[c.band_to].toLowerCase()}` : ", now benign")
    : "";
  return `${c.point}: ${name} ${moved}${band} (worst at ${fmtStepTime(c.time)})`;
}

export default function RunCommentary({ comparison, config, title, sx }) {
  const [all, setAll] = useState(false);
  if (!comparison) return null;
  const metrics = metricsByField(config);
  const changes = comparison.changes || [];
  const shown = all ? changes : changes.slice(0, SHOWN);
  const inRange = (comparison.notes || []).filter(n => n.note === "now_in_range");

  return (
    <Alert severity={VERDICT_SEVERITY[comparison.verdict] || "info"} sx={sx}>
      {title && <AlertTitle>{title}</AlertTitle>}
      <Typography variant="body2" sx={{ fontWeight: 600 }}>{comparison.headline}</Typography>
      {shown.length > 0 && (
        <Box component="ul" sx={{ m: 0, mt: 0.5, pl: 2.5 }}>
          {shown.map((c, i) => (
            <Typography component="li" variant="body2" key={`${c.point_id}:${c.field}:${i}`}>
              {c.direction === "worse" ? "Worse" : "Better"} — {changeText(c, metrics[c.field])}
            </Typography>
          ))}
        </Box>
      )}
      {changes.length > SHOWN && (
        <Button size="small" color="inherit" onClick={() => setAll(a => !a)} sx={{ mt: 0.5 }}>
          {all ? "Show fewer" : `Show all ${changes.length} changes`}
        </Button>
      )}
      {inRange.length > 0 && (
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          Now inside the forecast's range: {inRange.map(n => n.point).join(", ")}.
        </Typography>
      )}
    </Alert>
  );
}
